module.exports = __webpack_public_path__ + "media/images/teams/logo__3-8d1ea43dec807d1cbd82887a8e09d0cd.svg";